/**
 * @generated SignedSource<<8ed76b9ac13ff63b5efd57b26ecdaa20>>
 * @relayHash 267201ef0fc91b8e6067223e2b3c2b2c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4130351b017209d6adb541791ba3ab36645af4c490037433ed3f9c3e1b09d1ca

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessAttachmentsAppMemoQuery } from './JiraBusinessAttachmentsAppMemoQuery.graphql';

import blockAttachmentDownloadSegregation_provider from '@jira/platform__graphql-relay-provider/src/block-attachment-download-segregation.relayprovider';

const node: PreloadableConcreteRequest<JiraBusinessAttachmentsAppMemoQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4130351b017209d6adb541791ba3ab36645af4c490037433ed3f9c3e1b09d1ca",
    "metadata": {},
    "name": "JiraBusinessAttachmentsAppMemoQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider": blockAttachmentDownloadSegregation_provider
    }
  }
};

export default node;
